import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { BaseURL } from "../../base/env";

const PusherService = {
  instance: null,
  isStarted: false,

  init: (interest_list) => {
    if (!PusherService.instance) {
      PusherService.instance = new PusherPushNotifications.Client({
        instanceId: process.env.REACT_APP_PUSHER_INSTANCE_ID,
      });
      PusherService.instance
        .start()
        .then(() => {
          PusherService.isStarted = true;
          return PusherService.instance.setDeviceInterests(interest_list);
        })
        .then(() => {
          // console.log(`Successfully subscribed to interest: ${interest_list}`);
        })
        .catch((error) => {
          // console.error('Error initializing Pusher Beams:', error);
        });
    } else if (!PusherService.isStarted) {
      return PusherService.instance.start().then(() => {
        PusherService.isStarted = true;
        PusherService.instance.setDeviceInterests(interest_list);
      });
    } else {
      PusherService.instance
        .setDeviceInterests(interest_list)
        .then(() => {
          // console.log(`Successfully subscribed to interest: ${interest_list}`);
        })
        .catch((error) => {
          // console.error('Error setting interest:', error);
        });
    }
  },

  isPusherStarted: () => PusherService.isStarted,

  setUser: (email, token, interested) => {
    if (!PusherService.instance) {
      return;
    }
    const interest = `${interested}-${email}`;

    const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
      // Use the same API base URL as the rest of the app to avoid undefined envs
      url: `${BaseURL}/api/v1/notification/beams/`,
      queryParams: {
        beam_id: interest,
      },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    PusherService.instance
      .setUserId(email, beamsTokenProvider)
      .then(() => {
        // console.log(`Successfully authenticated and set userId: ${email}`);
      })
      .catch((error) => {
        // console.error('Error setting userId in Pusher Beams:', error);
      });
  },

  logout: () => {
    if (PusherService.instance && PusherService.isStarted) {
      const { instance } = PusherService;
      instance.getDeviceInterests().then((interests) => {
        instance.clearAllState().then(() => {
          PusherService.init(interests);
        });
      });
    }
  },

  reconnect: (interests) => {
    if (PusherService.instance && PusherService.isStarted) {
      const { instance } = PusherService;
      instance.clearAllState().then(() => {
        PusherService.init(interests);
      });
    }
  },
};

export default PusherService;
